import React, { useState } from 'react';
import {
  Row,
  Col,
  Select,
} from 'antd';

import CheckRows from '../CheckRows';
import {
  overtimeRows,
} from './timeTrackingConstants';
import OnTraccrNumberInput from '../../common/inputs/OnTraccrNumberInput';
import DisplayText from '../../common/text/DisplayText';
import OnTraccrSwitch from '../../common/inputs/OnTraccrSwitch';

const afterHoursInput = ({ disabled, onChange, defaultValue, maxValue }) => (
  <Row gutter={4} align="middle" style={{ marginTop: 10 }}>
    <Col>
      <DisplayText title="after" style={{ marginBottom: 0, opacity: disabled ? 0.4 : 1 }} />
    </Col>
    <Col>
      <OnTraccrNumberInput
        style={{ width: 65 }}
        disabled={disabled}
        onChange={(value) => onChange(value)}
        onPressEnter={(e) => onChange(e.target.value)}
        defaultValue={defaultValue}
        min={0}
        max={maxValue}
      />
    </Col>
    <Col>
      <DisplayText title="hours" style={{ marginBottom: 0, opacity: disabled ? 0.4 : 1 }} />
    </Col>
  </Row>
);
const wageInput = ({ disabled, onChange, defaultValue }) => (
  <Row gutter={4} align="middle" style={{ marginTop: 10 }}>
    <Col>
      <DisplayText title="wage x" style={{ marginBottom: 0, opacity: disabled ? 0.4 : 1 }} />
    </Col>
    <Col>
      <OnTraccrNumberInput
        style={{ width: 65 }}
        disabled={disabled}
        onChange={(value) => onChange(value)}
        onPressEnter={(e) => onChange(e.target.value)}
        defaultValue={defaultValue}
        min={0}
        max={99}
        step={0.25}
      />
    </Col>
  </Row>
);

const options = [
  { label: 'Overtime', value: 'overtime' },
  { label: 'Double Time', value: 'double' },
];

const overtimeInput = ({ disabled, onChange, defaultValue = 'overtime' }) => (
  <Row gutter={4} align="middle" style={{ marginTop: 10 }}>
    <Col>
      <Select
        value={defaultValue}
        options={options}
        disabled={disabled}
        onChange={onChange}
        style={{ width: 125 }}
      />
    </Col>
  </Row>
);

const workweekStartDayInput = ({ disabled, onChange, defaultValue = 7 }) => (
  <Row gutter={4} align="middle" style={{ marginTop: 10 }}>
    <Col>
      <Select
        value={defaultValue}
        options={[
          { value: 7, label: 'Sunday' },
          { value: 1, label: 'Monday' },
          { value: 2, label: 'Tuesday' },
          { value: 3, label: 'Wednesday' },
          { value: 4, label: 'Thursday' },
          { value: 5, label: 'Friday' },
          { value: 6, label: 'Saturday' },
        ]}
        disabled={disabled}
        onChange={onChange}
        style={{ width: 125 }}
      />
    </Col>
  </Row>
);

const secondRowInputs = [
  afterHoursInput, // Weekly Overtime
  workweekStartDayInput, // Workweek Start Day
  afterHoursInput, // Daily Overtime
  afterHoursInput, // Daily Double Time
  wageInput, // Saturday Pay Rate
  overtimeInput, // Saturday Overtime
  wageInput, // Sunday Pay Rate
  overtimeInput, // Sunday Overtime
  () => null, // Overtime Eligibility Selection
];

export default function AutomaticOvertime({
  settings,
  onSettingsChange,
  immediateToggleCommit = false,
}) {
  const [settingsEnabled, setSettingsEnabled] = useState({});

  return (
    <CheckRows
      data={overtimeRows}
      getView={(index) => {
        const row = overtimeRows[index];
        const setting = settings[row.key];
        const isWorkweekStartDay = row.key === 'workweekStartDay';
        const enabled = (
          (setting && setting > 0)
          || (setting && (setting === 'overtime' || setting === 'double'))
          || settingsEnabled[row.key]
          || isWorkweekStartDay
        );
        const disableOTEligibility = row.key === 'otEligibilitySelectionEnabled' && !settings.dailyOvertime;
        return (
          <Row justify="end" style={{ marginRight: 56 }}>
            <Col>
              {!isWorkweekStartDay && (
                <Row justify="end">
                  <OnTraccrSwitch
                    value={enabled && !disableOTEligibility}
                    disabled={disableOTEligibility}
                    onChange={(checked) => {
                      if (checked && (row.key === 'saturdayOvertime' || row.key === 'sundayOvertime')) {
                        return onSettingsChange({ [row.key]: 'overtime' });
                      }
                      if (row.key === 'seventhPay' || row.key === 'otEligibilitySelectionEnabled') {
                        return onSettingsChange({ [row.key]: checked });
                      }
                      if (!checked) {
                        const payload = { [row.key]: null };
                        if (row.key === 'dailyOvertime') {
                          payload.otEligibilitySelectionEnabled = false;
                        }
                        onSettingsChange(payload);
                      } else if (immediateToggleCommit) {
                        onSettingsChange({ [row.key]: true });
                      } else {
                        setSettingsEnabled({ [row.key]: true });
                        if (row.key !== 'saturdayOvertime' && row.key !== 'sundayOvertime') {
                          setTimeout(() => {
                            setSettingsEnabled((prev) => ({ ...prev, [row.key]: false }));
                          }, 5000);
                        }
                      }
                    }}
                  />
                </Row>
              )}
              {secondRowInputs[index]({
                maxValue: row.maxValue,
                disabled: !enabled && !isWorkweekStartDay,
                onChange: (value) => {
                  onSettingsChange({ [row.key]: value });
                },
                defaultValue: setting ?? (isWorkweekStartDay ? 7 : undefined),
              })}
            </Col>
          </Row>
        );
      }}
    />
  );
}
